import React, { useRef, useState } from "react";
import { formatarHora } from "../../services/conversaoTimer";
import ModalCheckinQr from "./modalCheckinQr";
import { FaCheck } from "react-icons/fa";
import api from "../../services/axios";
import ModalPesquisa from "../../components/modal/modalPesquisa";
import { toast } from "react-toastify";

function LinhaAgenda(props) {
  const [showModalQr, setShowModalQr] = useState(false);
  const [showModalPesquisa, setShowModalPesquisa] = useState(false);
  const [pesquisa, setPesquisa] = useState(null);
  const [abrirQrAposPesquisa, setAbrirQrAposPesquisa] = useState(false);
  const [verificando, setVerificando] = useState(false);
  const abrirQrAposPesquisaRef = useRef(false);

  const convidado = props.item?.agenda?.participantes?.find(
    (p) => p?.usuario?.tipo === "convidado"
  )
    || props.item?.agenda?.participantes?.find(
      (p) =>
        Number(p.id_usuario ?? p.usuario?.id) !== Number(props.item?.id_usuario)
    )
    || props.item?.agenda?.participantes?.[0];

  const abrirLeitorQr = () => {
    setShowModalQr(true);
  };

  const fecharLeitorQr = () => {
    setShowModalQr(false);
    props.handle?.();
  };

  const handleModalPesquisa = () => {
    setShowModalPesquisa((prev) => !prev);
  };

  /** Apenas verifica/abre pesquisa pendente (quando já há presença). */
  const verificaPesquisaUsuario = async () => {
    if (!convidado?.usuario?.id) return;

    try {
      const resp = await api.post("/verifica-pesquisa-usuario", {
        id_usuario: convidado.usuario.id,
      });
      if (resp.status === 200) {
        if (resp.data.pesquisas.length > 0) {
          abrirQrAposPesquisaRef.current = false;
          setAbrirQrAposPesquisa(false);
          setPesquisa(resp.data.pesquisas[0]);
          setShowModalPesquisa(true);
        } else {
          toast.info("Nenhuma pesquisa pendente para este usuário");
        }
      }
    } catch (err) {
      toast.error("Erro ao verificar pesquisa pendente.");
    }
  };

  /**
   * Fluxo de check-in: pesquisa pendente primeiro, depois leitor de QR.
   */
  const iniciarCheckin = async () => {
    if (verificando || !convidado?.usuario?.id) return;
    setVerificando(true);

    try {
      const resp = await api.post("/verifica-pesquisa-usuario", {
        id_usuario: convidado.usuario.id,
      });

      if (resp.status === 200 && resp.data.pesquisas?.length > 0) {
        abrirQrAposPesquisaRef.current = true;
        setAbrirQrAposPesquisa(true);
        setPesquisa(resp.data.pesquisas[0]);
        setShowModalPesquisa(true);
      } else {
        abrirLeitorQr();
      }
    } catch (err) {
      toast.error("Erro ao verificar pesquisa. Abrindo leitor de QR…");
      abrirLeitorQr();
    } finally {
      setVerificando(false);
    }
  };

  const aoResponderPesquisa = () => {
    if (abrirQrAposPesquisaRef.current) {
      abrirQrAposPesquisaRef.current = false;
      setAbrirQrAposPesquisa(false);
      abrirLeitorQr();
    }
  };

  return (
    <>
      <ModalCheckinQr
        titulo="Check-in da reunião"
        show={showModalQr}
        toggleModal={fecharLeitorQr}
        item={props.item}
        onCheckinConfirmado={() => props.handle?.()}
      />
      <ModalPesquisa
        titulo="Pesquisa"
        show={showModalPesquisa}
        toggleModal={handleModalPesquisa}
        pesquisa={pesquisa}
        tipoUsuario={"convidado"}
        texto={
          "Para liberar a entrada na proxima reunião por favor nos diga o que achou"
        }
        close={!abrirQrAposPesquisa}
        onRespondido={aoResponderPesquisa}
      />
      {convidado ? (
        <div
          className={`linha-agenda`}
          onClick={() => {
            if (!convidado?.presenca) {
              iniciarCheckin();
            } else {
              verificaPesquisaUsuario();
            }
          }}
        >
          {props.item.agenda.tipo !== "reuniao_negocio" ? (
            <div>{props.item.agenda.tipo.replace("_", " ")}</div>
          ) : (
            false
          )}
          <div
            className={`label-agenda`}
          >{`${props.item.agenda.nome} - ${props.item.agenda?.participantes[1]?.usuario?.nome}`}</div>
          <div className={`label-hora`}>
            {formatarHora(props.item.agenda.dt_hora_inicio).substring(0, 5)} /{" "}
            {formatarHora(props.item.agenda.dt_hora_fim).substring(0, 5)}
          </div>
          {props.item.agenda.tipo === "reuniao_negocio" ? (
            <div className={`area-reunia-nogocio`}>
              <div className={`d-flex`}>
                <div style={{ marginRight: "5px", color: "#007f1d" }}>
                  {convidado?.presenca ? <FaCheck /> : false}
                </div>
                <div>
                  {convidado?.usuario?.nome} / {convidado?.usuario?.empresa}
                </div>
              </div>
            </div>
          ) : (
            false
          )}
        </div>
      ) : (
        false
      )}
    </>
  );
}

export default LinhaAgenda;
